/* eslint-disable @typescript-eslint/no-non-null-assertion */
import type { ElibooApp } from '@eliboo/api-models';
import type { TuiConfirmData } from '@taiga-ui/kit';

import { HttpContext } from '@angular/common/http';
import { inject } from '@angular/core';
import { ALLOW_ANONYMOUS } from '@delon/auth';
import { useApiPageApplicationVersion } from '@eliboo/api/eliboo-app';
import { TuiResponsiveDialogService } from '@taiga-ui/addon-mobile';
import { TuiAlertService } from '@taiga-ui/core';
import { TUI_CONFIRM } from '@taiga-ui/kit';
import dsBridge from 'dsbridge';
import { map, switchMap, tap, timer } from 'rxjs';

export function useCheckVersion(appName: string, versionCode: number, hostUrl?: string) {
  const { api, url: apiUrl } = useApiPageApplicationVersion();
  if (hostUrl) {
    apiUrl.update((val) => {
      if (!val.startsWith('http')) {
        if (hostUrl!.endsWith('/')) {
          hostUrl = hostUrl!.slice(0, -1);
        }
        return hostUrl + val;
      }
      return val;
    });
  }
  const dialogs = inject(TuiResponsiveDialogService);
  const alert = inject(TuiAlertService);

  function getVersionApi() {
    const body: ElibooApp.ApplicationVersionVO = {
      md5: appName,
      releaseNotesEnum: 'WEB',
      wrapperX: { orderby: ['modifyTime.desc'] },
    };
    return api(body, { context: new HttpContext().set(ALLOW_ANONYMOUS, true) }).pipe(map((res) => res.data?.[0]));
  }
  function checkVersionOnce(showToast = false) {
    return getVersionApi().pipe(
      tap((res) => {
        if (res?.versionCode) {
          console.log('versionCode', versionCode, 'res.versionCode', res.versionCode!);
          if (versionCode < res.versionCode!) {
            reload(dialogs);
          } else {
            if (showToast) {
              alert.open('未检测到新版本').subscribe();
            }
          }
        }
      }),
    );
  }

  function checkVersion() {
    const intervalTime = 3 * 60 * 1000;

    timer(0, intervalTime)
      .pipe(switchMap(() => checkVersionOnce(false)))
      .subscribe();
  }
  return { checkVersion, getVersionApi, checkVersionOnce };
}
function reload(dialogs: TuiResponsiveDialogService) {
  const data: TuiConfirmData = {
    content: '应用可能已发布新版本，请点击刷新才能生效！',
    no: '忽略',
    yes: '刷新',
  };

  dialogs
    .open<boolean>(TUI_CONFIRM, {
      closeable: false,
      data,
      label: '提醒',
      size: 'm',
    })
    .pipe(
      tap((res) => {
        if (res) {
          try {
            const isInApp = isInElibooApp();
            console.log('isInApp', isInApp);
            if (isInApp) {
              clearCache(true).then((res) => {
                console.log('clearCache.res', res);
                if (!res) location.reload();
              });
            } else {
              location.reload();
            }
          } catch (error) {
            location.reload();
          }
        }
      }),
    )
    .subscribe();
}
function isInElibooApp() {
  const platform = dsBridge.call('getPlatform', '');
  if (platform && (platform.includes('android') || platform.includes('flutter'))) {
    return true;
  }
  return false;
}

function clearCache(reload: boolean) {
  return new Promise((resolve, rej) => {
    dsBridge.call('clearCache', reload, (res) => {
      resolve(res);
    });
  });
}
